import {
  baseUniDriverFactory,
  UniDriver,
} from '@wix/wix-ui-test-utils/unidriver';
import { TagUniDriver } from '@wix/design-system/dist/testkit/unidriver';

export function NestedTableDragOverlayUniDriver(
  base: UniDriver,
  body: UniDriver,
) {
  const getDepthLimitMessageDriver = () =>
    TagUniDriver(
      base.$('[data-hook="nested-table-dnd-depth-limit-message"]'),
      body,
    );

  const getDisableMessageDriver = () =>
    TagUniDriver(
      base.$('[data-hook="nested-table-dnd-disabled-message"]'),
      body,
    );

  return {
    ...baseUniDriverFactory(base),
    depthLimitMessageExists: () => getDepthLimitMessageDriver().exists(),
    getDepthLimitMessage: () => getDepthLimitMessageDriver().getLabel(),
    disableMessageExists: () => getDisableMessageDriver().exists(),
    getDisableMessage: () => getDisableMessageDriver().getLabel(),
  };
}
